// import { IPage } from '@types'
// import LoadingOverlay from 'components/common/LoadingOverlay'
// import Layout from 'components/layouts/Layout'
//
// import dynamic from 'next/dynamic'
//
// let CartView = dynamic(() => import('components/cart/CartView'), {
//   ssr: false,
//   loading: () => (
//     <main className='relative flex-grow bg-white pb-12 md:pb-20'>
//       <LoadingOverlay className='h-5 w-5 mx-2.5 bg-accent' open />
//     </main>
//   ),
// })
//
// let CartPage: IPage = () => <CartView />
//
// CartPage.getLayout = (page) => (
//   <Layout title={page.props.title}>{page}</Layout>
// )
//
// export const getStaticProps = () => ({
//   props: {
//     title: 'Ваша корзина',
//   },
// })
//
// export default CartPage

import { IPage } from '@types'
import LoadingOverlay from 'components/common/LoadingOverlay'
import Layout from 'components/layouts/Layout'

import dynamic from 'next/dynamic'

let CartView = dynamic(() => import('components/cart/CartView/CartView'), {
  ssr: false,
  loading: () => (
    <main className='relative flex-grow bg-white pb-12 md:pb-20'>
      <LoadingOverlay className='h-5 w-5 mx-2.5 bg-accent' open />
    </main>
  ),
})

let CartPage: IPage = () => <CartView />

CartPage.getLayout = (page) => (
  <Layout title={page.props.title}>{page}</Layout>
)

export const getStaticProps = () => ({
  props: {
    title: 'Ваша корзина',
  },
})

export default CartPage
